'use client';

import { c as _c } from "react/compiler-runtime";
import { CmsPageTakeover } from '@spa/top-level-components/cms-page/CmsComponentPage';
import LinkComponent from '@spa/components/link/link.component';
import { ReactNode } from 'react';
import styles from './takeover-layer-link.component.module.scss';
export interface Props {
  readonly takeover: CmsPageTakeover | null;
}
function TakeoverLayerLinkComponent(t0) {
  const $ = _c(2);
  const {
    takeover
  } = t0;
  let t1;
  if ($[0] !== takeover) {
    t1 = takeover !== null && takeover.link !== null && <div aria-hidden="true" className={styles.layer} data-testid="takeover-link-layer-container"><LinkComponent link={takeover.link} className={`takeover-link-layer ${styles["layer-link"]}`} dataTestId="takeover-link-layer" preventForwarding={true} /></div>;
    $[0] = takeover;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default TakeoverLayerLinkComponent;